export default "__VITE_ASSET__DzceKGMT__"